export function FieldError({ id, messages }: { id: string; messages: string[] }) {
  if (messages.length === 0) return null;
  return (
    <div id={id} role="alert" className="small" style={{ color: 'var(--danger)' }}>
      {messages.join('。')}
    </div>
  );
}
